import * as d3 from 'd3';
import { svg } from 'd3';
import React, {useEffect, useRef} from 'react';


//D3-Component
//I need a way for this to update every time the data changes;
//need to use useRef to keep the mutable object (data) during updates
//work to do
    //estabish padding
    //set up x-axis
    //set up temperature labels above bar
    //recognize that the timestamp module must be multiplied by 1000 for JS to read it properly
    
export default function Hourly({data, unit}) {

    const ref = useRef(null);

    //svg canvas size
    const height = 220;
    const width = 1700;
    const padding = 40;
    const paddingTop = 60;
    const barWidth = 25; 

    //ComponentDidMount()
    //This initializes the svg canvas on startup
    useEffect(()=> {
        const svg = d3.select(ref.current)
                      .attr("id", "celsiusChart")
                      .attr("width", width)
                      .attr("height", height)
                      .attr("x", 0)
                      .attr("y", 0);
        svg.append("g");
        }, [width, height]);

    //ComponentDidUpdate()
    useEffect((unit) => {
        if (data.length > 0 && ref.current){
            draw(data, unit);
        }        
    },[data,unit]);



    //ComponentDidUpdate()? 
    const draw = (data, unit) => {
        const svg = d3.select(ref.current);

        const extentDate = d3.extent(data, (d) => new Date(d[0]));
        const maxTemp = d3.max(data, (d) => d[1]);
        const minTemp = d3.min(data, (d)=> d[1]);
    
        //x-Scale    
        var xScale = d3.scaleTime()
        .domain(extentDate)
        .range([(padding/2), width - padding - barWidth - barWidth]);
    
        //y-Scale-temp
        var yScale = d3.scaleLinear()
        .domain([(minTemp-1),maxTemp])
        .range([height-padding, paddingTop])
        .nice();

        //y-Scale-precip
        var yScalePop = d3.scaleLinear()
        .domain([0, 1])
        .range([height-padding, paddingTop])
        .nice();


        //Full Update Sequence - Temperature Bars
        const updateTempBars = svg.selectAll("rect").data(data);
        let tempBars = updateTempBars  
                       .enter()
                       .append("rect")
                       .merge(updateTempBars)
                       .attr("class", "bar")
                        .attr("x", (d, i) => {
                            return xScale(new Date(d[0]))
                        })
                        .attr("y", (d, i) => {
                            return height-padding;
                        })
                        .attr("width", barWidth)
                        .attr("height", (d, i) => {
                            return 0;
                        })
                        .attr("fill", "var(--off-white)")
                        .attr("opacity", "0.5");    
            tempBars.transition().duration(1000)
                    .attr("opacity", 1)
                    .attr("height", (d) => height - yScale(d[1]) - padding)
                    .attr("y", (d) => yScale(d[1]));

            updateTempBars.exit().remove();
            

        //Full update sequence - Rain Bars
        const updateRainBars = svg.selectAll("rect2").data(data);
        let rainBars = updateRainBars
                          .enter()
                          .append("rect")
                          .merge(updateRainBars)
                          .attr("class", "rainbar")
                          .attr("x", (d, i) => {
                              return xScale(new Date(d[0]))+barWidth
                          })
                          .attr("y", (d, i) => {
                              return height-padding;
                          })
                          .attr("height", (d,i)=> {
                              return 0;
                          })
                          .attr("width", barWidth)
                          .attr("fill", "var(--blue)")
                          .attr("opacity", 0.25);
            rainBars
                .transition().duration(1000)
                    .attr("opacity", 0.5)
                    .attr("height", (d) => height - yScalePop(d[2])-padding)
                    .attr("y", (d) => yScalePop(d[2]));
            
            updateRainBars.exit().remove();

        //Full update sequence - Base Rain
        const updateBaseRain = svg.selectAll("rect3").data(data);
                updateBaseRain
                          .enter()
                          .append("rect")
                          .merge(updateBaseRain)
                          .attr("class", "rainbase")
                          .attr("x", (d, i)=> {
                              return xScale(new Date(d[0]))+barWidth
                          })
                          .attr("y", (d, i) => {
                              return height-padding-1
                          })
                          .attr("height", (d,i)=> {
                              return 1;
                          })
                          .attr("width", barWidth)
                          .attr("fill", "var(--blue)")
                          .attr("opacity", 0.5);
                        
            updateBaseRain.exit().remove();
        

        //Full update sequence - Label Temp Hourly
        const updateTempText = svg.selectAll("text").data(data);
        let tempText = updateTempText
                            .enter()
                            .append("text")
                            .merge(updateTempText)
                            .attr("class", "label-temp-hourly")
                            .text((d) => {
                                return (`${Math.round(d[1])}°`)
                                })
                            .attr("fill", "var(--off-white)")
                            .attr("x", (d) => xScale(d[0])+2.5)
                            .attr("y", height-padding-5);
            tempText.transition().duration(1000)
                    .attr("opacity", 1)
                    .attr("y", (d)=>yScale(d[1])-5);
            updateTempText.exit().remove();

        
        //Full update sequence - Label Time Axis
        const updateTimeText = svg.selectAll("text2").data(data);
        updateTimeText
                          .enter()
                          .append("text")
                          .merge(updateTimeText)
                          .attr("class", "label-time-hourly")
                          .text((d)=> {
                              const hour = new Date(d[0]).getHours();
                              const now = (new Date().getHours());
                              if (hour === now){
                                  return `now`
                              }
                              else if (hour>12) {
                                  return `${hour-12}pm`
                              }
                              else if(hour === 0){
                                  return `${12}am`
                              }
                              else if(hour === 12){
                                  return `${12}pm`
                              }
                              else {
                                  return `${hour}am`
                              }
                          })
                          .attr("fill", "var(--off-white)")
                          .attr("x", (d)=>xScale(d[0])+barWidth/3)
                          .attr("y", height-(padding/3));
                        
            updateTimeText.exit().remove();

        //Full update sequence - Rain Text 
        const updateRainText = svg.selectAll("text3").data(data);
        let rainText = updateRainText
                           .enter()
                           .append("text")
                           .merge(updateRainText)
                           .attr("class", "label-rain-hourly")
                           .text((d)=>{
                             return `${Math.round(d[2]*100)}%`
                           })
                           .attr("fill", "var(--blue)")
                           .attr("x", (d)=>xScale(d[0])+barWidth+2)
                           .attr("y", height-padding-10);

            rainText.transition().duration(1000)
                    .attr("opacity", 1)
                    .attr("y", (d)=>yScalePop(d[2])-5);

            updateRainText.exit().remove();
    }

    return (
        <div className="Hourly-Panel" id="hourly">
            <div className="hourly-key">
                <p id="key-temp">Temperature</p>
                <p id="key-rain">Chance of Precipitation</p>
            </div>
            <svg ref={ref}>
            </svg>
        </div>
    )
}